import React, { useEffect, useState } from "react";
import ExpensePage from "../../../../entities/DashboardPage/AccountingModule/Expense";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";

const Expense = () => {
  const [data, setData] = useState();
  const {showAlert} = useAlert()
  const [totalCount,setTotalCount] = useState();
  const [page,setPage] = useState(1);

  useEffect(() => {
    getOtherExpenses()
  },[page])

  const getOtherExpenses = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOtherExpense(page);
      if (result?.success) {
        setData(result?.data);
        setTotalCount(result?.data?.total)
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const deleteExpense = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteExpense(id);
      if (result?.success) {
        showAlert(result?.message, "success");
        getOtherExpenses()
        LoaderHelper.loaderStatus(false);
      } else {
        showAlert(result?.message, "success");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  return(
    <>
      <ExpensePage data={data} totalCount={totalCount} page={page} setPage={setPage} deleteExpense={deleteExpense}/>
    </>
  )
}

export default Expense